<!-- Projects -->
<div
  class="projects"
  (click)="isOpen = !isOpen"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
>
  @if (currentProject?.photoUrl) {
    <div class="project-logo">
      <img class="image" [src]="currentProject?.photoUrl" />
    </div>
  }
  <div class="name">{{ currentProject?.name }}</div>
  <mat-icon svgIcon="arrow-left" class="icon arrow-icon"></mat-icon>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPositions]="[
  {
    originX: 'center',
    originY: 'bottom',
    overlayX: 'center',
    overlayY: 'top',
    offsetY: 2
  }
  ]"
  (overlayOutsideClick)="isOpen = false"
>
  <div class="project-list">
    @for (project of projects; track project.id) {
      <div class="project-item" (click)="selectProject(project)">
        @if (project?.photoUrl) {
          <div class="project-logo">
            <img class="image" [src]="project?.photoUrl" />
          </div>
        }
        <div class="name">{{ project.name }}</div>
      </div>
    }
    @if (permissions | includesBy: 'project:create') {
      <div class="project-item create" (click)="createProject()">
        <div class="name">Create Project</div>
      </div>
    }
  </div>
</ng-template>